module.exports = __webpack_public_path__ + "img/orbit-homepage-background.7c183156.png";